import { createRouter, createWebHistory } from "vue-router";
import UserLogin from "../views/Login.vue";
import UserSignup from "../views/Signup.vue";
import ProductList from "../views/ProductList.vue";
import Home from "../views/Home.vue";
import ProductDetail from "../views/ProductDetail.vue";
import Cart from "../views/ShoppingCartPage.vue"; // Cartコンポーネントをインポート
import store from "../store";

const routes = [
  {
    path: "/productlist/:id",
    name: "ProductDetail",
    component: ProductDetail,
  },
  {
    path: "/",
    redirect: "/signup",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAuthenticated) {
        next("/signup");
      } else {
        next();
      }
    },
  },
  {
    path: "/productlist",
    component: ProductList,
  },
  {
    path: "/cart",
    name: "ShoppingCartPage",
    component: Cart,
    beforeEnter: (to, from, next) => {
    console.log("isAuthenticated:", store.getters.isAuthenticated); // デバッグ用
    if (!store.getters.isAuthenticated) {
      next("/signup");
    } else {
      next();
      }
    },
  },
  {
    path: "/login",
    name: "UserLogin",
    component: UserLogin,
  },
  {
    path: "/signup",
    name: "UserSignup",
    component: UserSignup,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
